<template>
  <div
    id="history-memo-detail-view"
    aria-hidden="true"
    class="modal"
    tabindex="-1"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <!-- BEGIN: Modal Header -->
        <div class="modal-header">
          <h2 class="font-medium text-base mr-auto">
            Memos And History
          </h2>
        </div>
        <!-- END: Modal Header -->
        <!-- BEGIN: Modal Body -->
        <div class="modal-body grid grid-cols-12">
          <div
            :class="{
              'col-span-12': !memos.length,
              'col-span-6': memos.length
            }"
          >
            <ServiceabilityChangeTimeline
              v-if="Object.keys(history?.timeline).length"
              :category="history?.category"
              :data="history?.timeline ?? {}"
            />
          </div>
          <div
            :class="{
              'col-span-12': !Object.keys(history?.timeline).length,
              'col-span-6': Object.keys(history?.timeline).length
            }"
          >
            <MemoContent :description="memos" />
          </div>
        </div>
        <!-- END: Modal Body -->
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from "vue";
import { useStore } from "@/store";
import MemoContent from "@/components/loan-application-details/audit-logs/MemoContent";
import ServiceabilityChangeTimeline from "../common/ServiceabilityChangeTimeline.vue";

export default defineComponent({
  components: {
    MemoContent,
    ServiceabilityChangeTimeline
  },
  props: {},
  setup(props) {
    const store = useStore();
    const history = computed(() => store.getters["memos/history"]);
    const memos = computed(() => store.getters["memos/memos"]);

    return {
      history,
      memos
    };
  }
});
</script>
